function truncateDecimalString(value: number, decimals: number): number {
  const stringValue = value.toString();
  const [integer, fraction = ""] = stringValue.split(".");
  const truncatedFraction = fraction.slice(0, decimals).padEnd(decimals, "0");
  return Number(`${integer}.${truncatedFraction}`);
}

export const formatNumber = (
  value: number,
  options?: { maximumFractionDigits?: number; minimumFractionDigits?: number }
) => {
  const numberToFormat = truncateDecimalString(
    value,
    options?.maximumFractionDigits || 2
  );
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    ...options,
  }).format(numberToFormat);
};
